module.exports = __webpack_public_path__ + "img/p4-p1-chuan.2cca8c62.png";